import { NgModule } from '@angular/core';
import { EdAssistUINavbarModule } from '@edassist-ui/navbar';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TuitionMobileMenuComponent } from './tuition-mobile-menu.component';
import { EdAssistUISliderModule } from '@edassist-ui/slider';
import { EdAssistUIClientLogoModule } from '@edassist-ui/client-logo';
import { StartApplicationButtonModule } from '@tuition/shared/components/start-application-button/start-application-button.module';
import { EdAssistUIIconModule } from '@edassist-ui/icon';
import { EdAssistUIHeadingModule } from '@edassist-ui/heading';
import { OtherServicesMobileModule } from '@tuition/shared/components/other-services-mobile';
import { SupportServicesMobileModule } from '@tuition/shared/components/support-services-mobile';
import { ProfileActionsMobileModule } from '@tuition/shared/components/profile-actions-mobile';
import { EdAssistUIAnchorModule } from '@edassist-ui/anchor';

const COMPONENTS = [TuitionMobileMenuComponent];

@NgModule({
	exports: COMPONENTS,
	declarations: COMPONENTS,
	imports: [
		EdAssistUIIconModule,
		EdAssistUINavbarModule,
		EdAssistUISliderModule,
		EdAssistUIClientLogoModule,
		StartApplicationButtonModule,
		EdAssistUIHeadingModule,
		CommonModule,
		RouterModule,
		OtherServicesMobileModule,
		SupportServicesMobileModule,
		ProfileActionsMobileModule,
		EdAssistUIAnchorModule
	]
})
class TuitionMobileMenuModule {}

export { TuitionMobileMenuModule };
